import { render, staticRenderFns } from "./showImage.vue?vue&type=template&id=4a1231fa&scoped=true&"
import script from "./showImage.vue?vue&type=script&lang=js&"
export * from "./showImage.vue?vue&type=script&lang=js&"
import style0 from "./showImage.vue?vue&type=style&index=0&id=4a1231fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1231fa",
  null
  
)

export default component.exports